<!--
Usage
import BaseImageEditor from "@/components/base/BaseImageEditor.vue";
Limitations
- This does cannot crop images that are not base64
-->

<template>
  <div class="base-file-viewer">
    <div class="base-file-viewer__inner">
      <img :src="fileModel || placeholder" alt="" />

      <div v-if="isLoading" class="base-file-viewer__loading">
        <b-spinner></b-spinner>
      </div>
    </div>

    <div class="base-file-viewer__actions">
      <button
        v-if="!!fileModel && !isHideCrop"
        class="base-file-viewer__btn-crop"
        @click="isModalVisible = true"
      >
        <b-icon icon="crop"></b-icon>
      </button>
    </div>

    <BaseModalCrop
      v-if="!hideCrop"
      v-model="fileModel"
      :modal-visible.sync="isModalVisible"
      @crop="$emit('crop', $event)"
    />
  </div>
</template>

<script>
// components
import BaseModalCrop from "@/components/base/BaseModalCrop.vue";

// utis
import { isBase64 } from "@/utils/file";

export default {
  components: {
    BaseModalCrop,
  },
  props: {
    /**
     * Base64 Format or path
     */
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    hideCrop: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  computed: {
    fileModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isHideCrop() {
      return !isBase64(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-file-viewer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 250px;
  margin-bottom: 20px;
  background-color: #f2f2f2;
  position: relative;
  &__loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
    color: rgb(100, 100, 100);
  }
  &__actions {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    button {
      padding: 0.75rem;
      background-color: white;
      cursor: pointer;
      color: #a783ff;
      border: none;
    }
  }
  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
